export default {
  path: 'deliveryAudit',
  component: () => import(/* webpackChunkName: "individual-view" */ '@/pages/audit/privatePersonnelList/index'),
  meta: {
    title: '交付审核',
    hideBack: true
  }
}
